import type { IconData } from '@stacksjs/iconify-core'

export const npm: IconData = {
  "body": "<g fill=\"currentColor\"><path d=\"M0 0h20v6.857H10V8H5.556V6.857H0zm1.111 5.714h2.222V2.286h1.111v3.428h1.112V1.143H1.11zm5.556-4.571v5.714h2.222V5.714h2.222V1.143zm5.555 0v4.571h2.222V2.286h1.112v3.428h1.11V2.286h1.112v3.428h1.11V1.143z\"/><path d=\"M10 4.7H9V2.2h1z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default npm
